import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
import "swiper/swiper-bundle.css";

import VCalendar from "v-calendar";
Vue.use(VCalendar, {
  componentPrefix: "v",
  backgroundColor: "#282C34",
  border: "1px solid #dadada",
});

import { abilitiesPlugin } from "@casl/vue";
import { AbilityBuilder, Ability } from "@casl/ability";

function defineAbilityFor() {
  const { can, cannot, build } = new AbilityBuilder(Ability as any);
  return build();
}
const ability = defineAbilityFor();

Vue.use(abilitiesPlugin, ability);

import { i18n } from "@/i18n";

import "./globalComponentRegistration";
import "./extensions";
Vue.config.productionTip = false;
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
